import { FormProvider } from "react-hook-form";
import {
  APPROVED_BUDGET,
  IS_ACTIVE,
  IS_APPROVE_CONTRACT,
  APPROVE_CONTRACT_AMOUNT_LIMIT,
  POSITION_NAME,
  IS_APPROVE_AP_INVOICE,
  APPROVE_AP_INVOICE_AMOUNT_LIMIT,
  IS_APPROVE_WORK_ORDER,
  APPROVE_WORK_ORDER_AMOUNT_LIMIT,
  IS_APPROVE_PENALTIES,
  APPROVE_PENALTIES_AMOUNT_LIMIT,
  DESCRIPTION,
  APPROVAL,
  APPROVE_AP_INVOICE_AMOUNT_YEARLY_LIMIT,
} from "./consts";
import useAddEditPosition from "./useAddEditPosition";
import { FormCheckbox, FormInput, Loader } from "@/components";
import bomPosition from "@/assets/bomPosition.png";
import { Button } from "@/components/ui";
import { AddEditPositionProps } from "./types";
const AddEditPosition = ({
  selectedPosition,
  isViewPosition,
  onCancel,
}: AddEditPositionProps) => {
  const {
    form,
    requiredFields,
    onSubmit,
    isAddPositionPending,
    isUpdatePositionPending,
  } = useAddEditPosition({
    selectedPosition,
    onCancel,
  });
  const { errors } = form.formState;

  return (
    <div className="flex flex-col gap-5 mt-4 bg-white rounded-lg p-4">
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="flex flex-row gap-5 items-center">
            <div className="flex flex-col gap-[30px] border-e-1 pr-5">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-[30px]">
                <FormInput
                  name={POSITION_NAME}
                  control={form.control}
                  label="Position Name"
                  placeholder="Please enter"
                  error={errors[POSITION_NAME]?.message}
                  isRequired={requiredFields.includes(POSITION_NAME)}
                  disabled={isViewPosition}
                  maxLength={30}
                  minLength={5}
                />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-[20px]">
                  <FormCheckbox
                    name={APPROVED_BUDGET}
                    control={form.control}
                    label="Approve Budgets"
                    error={errors[APPROVED_BUDGET]?.message}
                    isRequired={requiredFields.includes(APPROVED_BUDGET)}
                    disabled={isViewPosition}
                  />
                  {selectedPosition ? (
                    <FormCheckbox
                      name={IS_ACTIVE}
                      control={form.control}
                      label="Active"
                      error={errors[IS_ACTIVE]?.message}
                      isRequired={requiredFields.includes(IS_ACTIVE)}
                      disabled={isViewPosition}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-[10px]">
                <FormCheckbox
                  name={IS_APPROVE_CONTRACT}
                  control={form.control}
                  label="Approve Contract"
                  error={errors[IS_APPROVE_CONTRACT]?.message}
                  isRequired={requiredFields.includes(IS_APPROVE_CONTRACT)}
                  disabled={isViewPosition}
                  onChange={(val: boolean) => {
                    if (!val) {
                      form.setValue(APPROVE_CONTRACT_AMOUNT_LIMIT, "0");
                    }
                  }}
                />
                <FormInput
                  name={APPROVE_CONTRACT_AMOUNT_LIMIT}
                  control={form.control}
                  label="Approve Contract Amount Limit"
                  placeholder="0"
                  error={errors[APPROVE_CONTRACT_AMOUNT_LIMIT]?.message}
                  isRequired={requiredFields.includes(
                    APPROVE_CONTRACT_AMOUNT_LIMIT
                  )}
                  disabled={isViewPosition || !form.watch(IS_APPROVE_CONTRACT)}
                  variant="integer"
                  startIcon={<span>$</span>}
                />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-[10px]">
                <FormCheckbox
                  name={IS_APPROVE_WORK_ORDER}
                  control={form.control}
                  label="Approve Work Order"
                  error={errors[IS_APPROVE_WORK_ORDER]?.message}
                  isRequired={requiredFields.includes(IS_APPROVE_WORK_ORDER)}
                  disabled={isViewPosition}
                  onChange={(val: boolean) => {
                    if (!val) {
                      form.setValue(APPROVE_WORK_ORDER_AMOUNT_LIMIT, "0");
                    }
                  }}
                />
                <FormInput
                  name={APPROVE_WORK_ORDER_AMOUNT_LIMIT}
                  control={form.control}
                  label="Approve Work Order Amount Limit"
                  placeholder="0"
                  error={errors[APPROVE_WORK_ORDER_AMOUNT_LIMIT]?.message}
                  isRequired={requiredFields.includes(
                    APPROVE_WORK_ORDER_AMOUNT_LIMIT
                  )}
                  disabled={
                    isViewPosition || !form.watch(IS_APPROVE_WORK_ORDER)
                  }
                  variant="integer"
                  startIcon={<span>$</span>}
                />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-[10px]">
                <FormCheckbox
                  name={IS_APPROVE_PENALTIES}
                  control={form.control}
                  label="Approve Penalties"
                  error={errors[IS_APPROVE_PENALTIES]?.message}
                  isRequired={requiredFields.includes(IS_APPROVE_PENALTIES)}
                  disabled={isViewPosition}
                  onChange={(val: boolean) => {
                    if (!val) {
                      form.setValue(APPROVE_PENALTIES_AMOUNT_LIMIT, "0");
                    }
                  }}
                />
                <FormInput
                  name={APPROVE_PENALTIES_AMOUNT_LIMIT}
                  control={form.control}
                  label="Approve Penalties Amount Limit"
                  placeholder="0"
                  error={errors[APPROVE_PENALTIES_AMOUNT_LIMIT]?.message}
                  isRequired={requiredFields.includes(
                    APPROVE_PENALTIES_AMOUNT_LIMIT
                  )}
                  disabled={isViewPosition || !form.watch(IS_APPROVE_PENALTIES)}
                  variant="integer"
                  startIcon={<span>$</span>}
                />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-[10px]">
                <FormCheckbox
                  name={IS_APPROVE_AP_INVOICE}
                  control={form.control}
                  label="Approve AP Invoice"
                  error={errors[IS_APPROVE_AP_INVOICE]?.message}
                  isRequired={requiredFields.includes(IS_APPROVE_AP_INVOICE)}
                  disabled={isViewPosition}
                  onChange={(val: boolean) => {
                    if (!val) {
                      form.setValue(APPROVE_AP_INVOICE_AMOUNT_LIMIT, "0");
                      form.setValue(
                        APPROVE_AP_INVOICE_AMOUNT_YEARLY_LIMIT,
                        "0"
                      );
                    }
                  }}
                />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-[10px]">
                  <FormInput
                    name={APPROVE_AP_INVOICE_AMOUNT_LIMIT}
                    control={form.control}
                    label="Approval Limit Per Invoice"
                    labelClassName="text-[10px] line-clamp-none whitespace-nowrap"
                    placeholder="0"
                    error={errors[APPROVE_AP_INVOICE_AMOUNT_LIMIT]?.message}
                    isRequired={requiredFields.includes(
                      APPROVE_AP_INVOICE_AMOUNT_LIMIT
                    )}
                    disabled={
                      isViewPosition || !form.watch(IS_APPROVE_AP_INVOICE)
                    }
                    variant="integer"
                    startIcon={<span>$</span>}
                  />
                  <FormInput
                    name={APPROVE_AP_INVOICE_AMOUNT_YEARLY_LIMIT}
                    control={form.control}
                    label="Yearly Approval Limit"
                    labelClassName="text-[10px] line-clamp-none whitespace-nowrap"
                    placeholder="0"
                    error={
                      errors[APPROVE_AP_INVOICE_AMOUNT_YEARLY_LIMIT]?.message
                    }
                    isRequired={requiredFields.includes(
                      APPROVE_AP_INVOICE_AMOUNT_YEARLY_LIMIT
                    )}
                    disabled={
                      isViewPosition || !form.watch(IS_APPROVE_AP_INVOICE)
                    }
                    variant="integer"
                    startIcon={<span>$</span>}
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 gap-[10px]">
                <FormInput
                  name={DESCRIPTION}
                  control={form.control}
                  label="Description"
                  placeholder="Please enter"
                  error={errors[DESCRIPTION]?.message}
                  isRequired={requiredFields.includes(DESCRIPTION)}
                  disabled={isViewPosition}
                />
              </div>
              {errors[APPROVAL]?.message && (
                <p className="text-red-500 text-[10px] mt-1">
                  {errors[APPROVAL]?.message as string}
                </p>
              )}
            </div>
            <div className="flex items-center justify-center w-[50%]">
              <img src={bomPosition} alt="bom-position" />
            </div>
          </div>
          <div className="flex flex-row gap-5 mt-5 justify-end">
            <Button
              variant="outline"
              type="button"
              onClick={onCancel}
              disabled={isAddPositionPending || isUpdatePositionPending}
            >
              Cancel
            </Button>
            {!isViewPosition && (
              <Button
                type="submit"
                disabled={isAddPositionPending || isUpdatePositionPending}
              >
                {isAddPositionPending ||
                  (isUpdatePositionPending && (
                    <Loader variant="secondary" />
                  ))}{" "}
                Save
              </Button>
            )}
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default AddEditPosition;
